import { ReactNode } from 'react';

export type SubtitleItemProps = {
  children: ReactNode;
  type: 'highlight' | 'positive' | 'warning' | 'negative';
};

export const SubtitleItem = ({ type, children }: SubtitleItemProps) => (
  <div className={`subtitle ${type}`}>{children}</div>
);
